import axios from '@/api/axios'

const changeEnrollment = (feedback) => {
  return axios.post('/applications', feedback)
}

const changeEnrollmentStatus = (feedbackId, data) => {
  return axios.put(`/applications/${feedbackId}/status`, data)
}

const changeEnrollmentDocuments = (feedbackId, data) => {
  return axios.put(`/applications/${feedbackId}/documentsCorrectness`, data)
}

const getEnrollmentList = (params) => {
  return axios.get('/applications/listForAdmin', {params})
}

const getEnrollmentInfo = (id) => {
  return axios.get(`/applications/${id}`)
}

export default {
  getEnrollmentList,
  getEnrollmentInfo,
  changeEnrollment,
  changeEnrollmentStatus,
  changeEnrollmentDocuments,
}
